<template>
  <div style="height: 100%;overflow: auto;">
    <grid ref="myGrid" :gridConfigUrl="gridConfigUrl">
      <template slot="topNoSelectMenus">
        <grid-menu-a
          name="打印账单"
          style="margin-right: 3px;"
          class="btn btn-hollow-dark"
          @menu-click="handlePrintTrade"
        >
        </grid-menu-a>
      </template>
    </grid>
    <el-dialog :visible.sync="visible" custom-class="whaty-dialog-form"
               @close="handleDialogClose" width="46%">
      <div slot="title" class="popup-head">
        <span class="popup-tit">导出订单</span>
      </div>
      <div>
        <el-scrollbar class="whaty-scroll">
          <div>
            <common-form
              ref="myForm"
              :formConfig="formConfig"
              :showHeader="false"
              :showFooter="false"
            ></common-form>
          </div>
        </el-scrollbar>
      </div>
      <!--<div slot="footer" class="popup-foot" style="text-align: right">-->
        <!--<a class="btn btn-solid" @click="handleSubmit">提交</a>-->
        <!--<a class="btn btn-hollow" @click="handleCancel">取消</a>-->
      <!--  <a href="javascript:" class="btn btn-anti-default" @click="handleCancel">取消</a>-->
      <!--  <a href="javascript:" class="btn btn-solid-primary" @click="handleSubmit">导出</a>-->
      <!--</div>-->
      <div slot="footer" class="popup-foot group">
        <a href="javascript:" class="btn btn-anti-default" @click="handleCancel">取消</a>
        <a href="javascript:" class="btn btn-solid-primary" @click="handleSubmit">导出</a>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Grid from '../../../../components/grid/grid'
  import GridMenuA from '../../../../components/grid-menu/grid-menu-a.vue'
  import CommonForm from '../../../../components/grid/common-form'
  import util from '@/libs/util'

  export default {
    components: {
      Grid,
      GridMenuA,
      CommonForm
    },
    name: 'trade-search',
    data() {
      return {
        visible: false,
        clientId: this.$route.query.clientId,
        customerCode: this.$route.query.customerCode,
        formConfig: {
          title: '打印账单',
          fields: [{
            id: 'month',
            title: '月份',
            name: '月份',
            type: 'month',
            required: true,
            canEdit: true,
            placeholder: '请选择月份'
          }]
        }
      }
    },
    computed: {
      gridConfigUrl: function () {
        return this.$route.meta.url
      }
    },
    methods: {
      handlePrintTrade: function () {
        this.visible = true
      },
      resetForm: function () {
        if (this.$refs.myForm) {
          this.$refs.myForm.resetForm()
        }
      },
      handleDialogClose: function () {
        this.resetForm()
      },
      handleSubmit: function () {
        this.$refs.myForm.$refs['ruleForm'].validate((valid) => {
          // 校验通过
          if (valid) {
            let month = this.$refs.myForm['ruleForm'].month
            this.$refs.myGrid.hiddenFormAction = util.baseUrl + '/entity/pay/tradeSearch/export'
            this.$refs.myGrid.hiddenFormTarget = '_blank'
            this.$refs.myGrid.hiddenFormParameters = []
            this.$refs.myGrid.hiddenFormParameters.push({name: 'month', value: month})
            this.$refs.myGrid.hiddenFormParameters.push({name: 'customerCode', value: this.customerCode})
            this.$refs.myGrid.hiddenFormParameters.push({name: 'clientId', value: this.clientId})
            this.$refs.myGrid.hiddenFormParameters.push({name: 'access_token', value: util.token()})
            this.$nextTick(_ => {
              this.$refs.myGrid.$refs.hiddenForm.submit()
            })
          }
        })
      },
      handleCancel: function () {
        this.resetForm()
        this.visible = false
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/custom/components/grid/pay/trade-search.vue